import {useRef, useEffect, useState} from 'react';
import { Route, Routes } from "react-router-dom";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faBell, faSortDown } from '@fortawesome/free-solid-svg-icons';
// import './navBar.css';
import DropDownMenu from '../component/dropdownmenu/dropDownMenu';

function Navbar() {
    const [data, setData] = useState('');
    const [notifications, setNotifications] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const ref = useRef(null);

    const getCookie = (name) => {
        const match = document.cookie
          .split("; ")
          .find((row) => row.startsWith(name + "="));
      
        if (!match) return null; // Return null if cookie not found
  
        try {
          const rawValue = match.split("=")[1];
        //   console.log(`Raw cookie value for ${name}:`, rawValue);
          return decodeURIComponent(rawValue); // Properly decode it
        } catch (error) {
          console.error(`Error decoding cookie ${name}:`, error);
          return null; // Return null if decoding fails
        }
    }

    async function forceLogout() {
        try {
            const loginToken = getCookie('data');
            const isLoggedOut = await axios(
                {
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/auth/logout`, 
                    method: 'POST',
                    /*headers: {
                        // ADDED Security Measure
                        //apiKey: 'qazwsxedcrfvvfrcdexswzaq',
                        // 'Access-Control-Allow-Origin': 'http://localhost:8080/api/auth/login'
                    },*/
                    data: {
                        loginToken: loginToken
                    }
                });
                // If response from backend is 200 then remove the loginToken cookie from client browser and redirect to Homepage
                if(isLoggedOut.status === 200) {
                    document.cookie = `data=; Max-Age=-99999999;`;
                    document.cookie = `username=; Max-Age=-99999999;`;
                    setTimeout(() => {location.href = '/login'}, 2000);
                // If repsonse was not successful then remove loginToken cookie anyway and redirect user to not found page
                } else {
                    document.cookie = `data=; Max-Age=-99999999;`;
                    document.cookie = `username=; Max-Age=-99999999;`;
                    setTimeout(() => {location.href = '/notfound'}, 1000)
                }   
        } catch (err) {
            console.log(err);
        }
    }

    const toggleMenu = () => {
        console.log(isMenuOpen);
        setIsMenuOpen(!isMenuOpen);
        if(!isMenuOpen) {
            document.querySelector(".navbar").style.overflow = "visible";
            document.querySelector(".navbar-container").style.flexDirection = "column";
        } else {
            document.querySelector(".navbar").style.overflow = "hidden";
            document.querySelector(".navbar-container").style.flexDirection = "row";
        }
    };

    // const displayPricing = async (e) => {
    //     e.preventDefault();
    //     console.log(window.location.href);
    //     if(window.location.href === 'http://localhost:5173/') {
    //         document.getElementById("pricingmodel").scrollIntoView({block: "center", behavior: 'smooth'});

    //     } else {
    //         window.location.href = '/#pricingmodel';
    //         document.getElementById("pricingmodel").scrollIntoView({block: "center", behavior: 'smooth'});
    //     }
    // }

    // async function getNotifications() {
    //     try {
    //         const cookie = document.cookie;
    //         const email = cookie.split(";")[2].split("=")[1].split('"')[1];
    //         const loginToken = cookie.split(";")[0].split("=")[1].split('"')[1];
    //         // console.log(loginToken);
    //         const getNotifications = await axios(
    //             {
    //                 url: `${import.meta.env.VITE_DEVBACKENDPATH}/api/notification/fetchall`, 
    //                 method: 'POST',
    //                 /*headers: {
    //                     contentType: "application/json",
    //                     connection: "keep-alive"
    //                 },*/
    //                 data: {
    //                     loginToken: loginToken,
    //                     email: email
    //                 }
    //             });
    //         if(getNotifications.data.length < 1){
    //             setNotifications({});
    //             return;
    //         }
    //         console.log(getNotifications);
    //         setNotifications(getNotifications.data);
    //         // return response.json();
    //     } catch (err) {
    //         console.log(err);
    //     }
    // }

    useEffect(() => {
        // If there is an id tag in the url scroll to that section
        if(window.location.href.split("#")[1] !== undefined) {
            document.getElementById(window.location.href.split("#")[1]).scrollIntoView({block: "center", behavior: 'smooth'});
        }

        const cookie = document.cookie;
        // check if username and loginToken exist in client cookies
        if(cookie.includes("username") && cookie.includes("data")){
            const username = getCookie('username');
            // add background color to navbar if logged in
            setData(username);
            document.querySelector("nav").className = "navbar navbar-expand-lg bg-black text-white navbar border-bottom border-white fixed-top p-3"
            //document.querySelector("nav").style.backgroundColor = "#5e84f1";
            // const fetchNotifications = getNotifications();
        } else if(cookie.includes("data")) {
            const comply = confirm("Something went wrong... please login again");
            if(comply) {
                forceLogout();
            } else {
                forceLogout();
            }
        } else if(cookie.includes("username")) {
            const comply = confirm("Something went wrong... please login again");
            if(comply) {
                document.cookie = `data=; Max-Age=-99999999;`;
                document.cookie = `username=; Max-Age=-99999999;`;
                setTimeout(() => {location.href = '/notfound'}, 1000);
            } else {
                document.cookie = `data=; Max-Age=-99999999;`;
                document.cookie = `username=; Max-Age=-99999999;`;
                setTimeout(() => {location.href = '/notfound'}, 1000);
            }
        }
        
        const element = ref.current;
    },[]);

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <div className="navbar-logo">
                    <a className='navbar-image' href='/'><FontAwesomeIcon id="navicon" icon={faGlobe} size='2xl'/></a>
                    <a className="navbar-logo-title" href='/'>Command Center</a>
                </div>

                {/* If logged in show a different selection of nav links */}
                {data ?
                    <div className={`nav-links ${isMenuOpen ? "show" : ""}`}>
                        <a className='link-item' href="https://sfs.titancompute.io"><svg class="width-40px height-40px color-white" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M160 96C124.7 96 96 124.7 96 160L96 224C96 259.3 124.7 288 160 288L480 288C515.3 288 544 259.3 544 224L544 160C544 124.7 515.3 96 480 96L160 96zM376 168C389.3 168 400 178.7 400 192C400 205.3 389.3 216 376 216C362.7 216 352 205.3 352 192C352 178.7 362.7 168 376 168zM432 192C432 178.7 442.7 168 456 168C469.3 168 480 178.7 480 192C480 205.3 469.3 216 456 216C442.7 216 432 205.3 432 192zM160 352C124.7 352 96 380.7 96 416L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 416C544 380.7 515.3 352 480 352L160 352zM376 424C389.3 424 400 434.7 400 448C400 461.3 389.3 472 376 472C362.7 472 352 461.3 352 448C352 434.7 362.7 424 376 424zM432 448C432 434.7 442.7 424 456 424C469.3 424 480 434.7 480 448C480 461.3 469.3 472 456 472C442.7 472 432 461.3 432 448z"></path></svg></a>
                        <a className='link-item' href="/dashboard">Dashboard</a>
                        <a className='link-item' href='/support'>Support</a>
                        <a className='link-item' href="/blog">Blog</a>
                        <a className='link-item' href="/documentation">Docs</a>
                        <div className="account-buttons">
                            <a className="" href="/notifications" id="notifications" role="button">
                                <FontAwesomeIcon icon={faBell}/>
                            </a>
                            <a className="" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {data}
                                <FontAwesomeIcon icon={faSortDown}/> 
                                <DropDownMenu />
                            </a>
                            {/* <ul className="" aria-labelledby="navbarDropdownMenuLink">
                                <a className='' href="/profile"><li className=''><FontAwesomeIcon icon={faUser} style={{marginRight: "5px"}}/>Profile</li></a>
                                <a className='' href="/settings"><li className=''><FontAwesomeIcon icon={faGear} style={{marginRight: "5px"}}/>Setting</li></a>
                                <a className='' href="/logout"><li className=''><FontAwesomeIcon icon={faArrowRightFromBracket} style={{marginRight: "5px"}}/>logout</li></a>
                            </ul> */}
                        </div>
                    </div>
                    :
                    <div className={`nav-links ${isMenuOpen ? "show" : ""}`}>
                        <a className='link-item' href="https://sfs.titancompute.io"><svg class="width-40px height-40px color-white" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M160 96C124.7 96 96 124.7 96 160L96 224C96 259.3 124.7 288 160 288L480 288C515.3 288 544 259.3 544 224L544 160C544 124.7 515.3 96 480 96L160 96zM376 168C389.3 168 400 178.7 400 192C400 205.3 389.3 216 376 216C362.7 216 352 205.3 352 192C352 178.7 362.7 168 376 168zM432 192C432 178.7 442.7 168 456 168C469.3 168 480 178.7 480 192C480 205.3 469.3 216 456 216C442.7 216 432 205.3 432 192zM160 352C124.7 352 96 380.7 96 416L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 416C544 380.7 515.3 352 480 352L160 352zM376 424C389.3 424 400 434.7 400 448C400 461.3 389.3 472 376 472C362.7 472 352 461.3 352 448C352 434.7 362.7 424 376 424zM432 448C432 434.7 442.7 424 456 424C469.3 424 480 434.7 480 448C480 461.3 469.3 472 456 472C442.7 472 432 461.3 432 448z"></path></svg></a>
                        <a className='link-item' href="/features">Features</a>
                        {/* <a className='link-item' onClick={ displayPricing }>Pricing</a> */}
                        <a className='link-item' href="/blog">Blog</a>
                        {/* <div className="auth-buttons"> */}
                            <a className='link-item' href="/login" id='navlogin'><div><p>Login </p></div></a>
                            <a className='link-item' href="/register" id='navregister'><div><p> Register</p></div></a>
                        {/* </div> */}
                    </div>
                }

                <div className="hamburger-menu" onClick={toggleMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </div>
        </nav>
    );    
}

export default Navbar;